import { useCategoryPageFilterKeys } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useRequestReferrer } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useRequestReferrer";
import { useRequestPageSize } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useRequestPageSize";
import { ICategoryPageFetchResultsOptions } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/__internal__/fetchResults/fetchResults";
import { ICategoryPageQueryKeys } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/createCategoryPageQueryKeys";
import { useCategoryPageQueryKeys } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQueryKeys";
import { useShowProductFirstResults } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/useShowProductFirstResults/useShowProductFirstResults";
import { useCurrentNavigationPath } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { useOneIndexedPageNumber } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useOneIndexedPageNumber";

export interface ICategoryPageRequestParams {
  queryKey: ICategoryPageQueryKeys;
  fetchResultsOptions: ICategoryPageFetchResultsOptions;
}

export const useCategoryPageRequestParams = (
  pageNumber?: number
): ICategoryPageRequestParams => {
  const showProductFirstResults = useShowProductFirstResults();
  const navigationPath = useCurrentNavigationPath();
  const filterKeys = useCategoryPageFilterKeys();
  const requestPageSize = useRequestPageSize();
  const oneIndexedPageNumber = useOneIndexedPageNumber();
  const requestPageNumber = pageNumber ?? oneIndexedPageNumber;
  const requestReferrer = useRequestReferrer();

  const queryKey = useCategoryPageQueryKeys(requestPageNumber);

  const fetchResultsOptions: ICategoryPageFetchResultsOptions = {
    showProductFirstResults,
    navigationPath,
    filterKeys,
    requestPageSize,
    oneIndexedPageNumber: requestPageNumber,
    requestReferrer,
  };

  return {
    queryKey,
    fetchResultsOptions,
  };
};
